<template>
  <div class="deliveryPosition">
    <div class="deliveryPosition_titleArea">
      <h3 class="title">投放位置</h3>
      <span class="tips">选择广告的展示位置</span>
    </div>
    <div class="deliveryPosition_option">
      <ul class="option_ul">
        <li
          class="ul_item"
          :class="{active:pos_type1 === 999}"
          @click="toufangewizhi('friend')"
        >
          <svg
            viewBox="0 0 48 48"
            style="margin-right: 8px; width: 48px;"
          >
            <path
              data-role="tertiary"
              d="M15.6299 27.2904l4.5089-4.4958v8.7804c-1.6284-.7473-2.7548-1.8154-3.4786-2.7067-.3721-.4583-.6374-.8695-.8095-1.1655a6.5295 6.5295 0 01-.1897-.349 3.9424 3.9424 0 01-.0311-.0634z"
            />
            <path
              data-role="secondary"
              d="M15.0674 20.1049l6.3487.0075-6.231 6.2089c-.6213-1.6762-.6525-3.2272-.5243-4.3695.066-.5873.1741-1.0661.2655-1.3975a6.4187 6.4187 0 01.117-.3813 4.2478 4.2478 0 01.0241-.0681zM21.1057 31.9157l.0076-6.3006 6.2269 6.209c-1.6808.6185-3.236.6433-4.3815.5092-.589-.0689-1.0692-.1798-1.4015-.2733a6.4828 6.4828 0 01-.3826-.1196 6.1976 6.1976 0 01-.0689-.0247zM28.1861 31.3561l-4.4159-4.4331h8.8127c-.7507 1.6213-1.8455 2.7283-2.7633 3.4344-.472.363-.8968.6197-1.2031.7854a6.5363 6.5363 0 01-.3612.182 3.5409 3.5409 0 01-.0692.0313z"
            />
            <path
              data-role="primary"
              d="M32.8885 25.9582l-6.2861-.0075 6.2309-6.2089c.6203 1.6757.6361 3.2261.4925 4.3682-.0738.5872-.1898 1.0659-.2871 1.3972a6.3112 6.3112 0 01-.1242.3813 3.2117 3.2117 0 01-.026.0697zM24.2458 19.1402l-4.5392-4.4953-.0282.0137-.0347.0173a6.521 6.521 0 00-.347.1891c-.2944.1716-.7034.4362-1.1597.8072-.8874.7215-1.9521 1.8445-2.7017 3.468h8.8105zM26.9765 14.0837l-.0076 6.3005-6.227-6.2089c1.6808-.6185 3.236-.6434 4.3815-.5093.5891.069 1.0693.1799 1.4016.2734.1662.0467.2953.089.3825.1196.0271.0094.0501.0178.069.0247zM27.9436 23.2709l4.4466-4.3729a4.642 4.642 0 00-.0314-.0696 6.5104 6.5104 0 00-.1826-.3632c-.1661-.3079-.4235-.7348-.7877-1.2088-.7082-.9217-1.8185-2.0197-3.4449-2.7681v8.7826z"
            />
            <path
              data-role="primary"
              fill-rule="evenodd"
              d="M13 4c-2.2091 0-4 1.7909-4 4v32c0 2.2091 1.7909 4 4 4h22c2.2091 0 4-1.7909 4-4V8c0-2.2091-1.7909-4-4-4H13zm22 2H13c-1.1046 0-2 .8954-2 2v32c0 1.1046.8954 2 2 2h22c1.1046 0 2-.8954 2-2V8c0-1.1046-.8954-2-2-2z"
              clip-rule="evenodd"
            />
          </svg>
          <div class="item_xinxi">
            <span class="text">朋友圈信息流</span>
            <span class="text">向浏览微信朋友圈的用户，精准展现广告</span>
          </div>
          <i class="item_icon">√</i>
        </li>
        <li
          class="ul_item"
          :class="{active:pos_type1 !== 999}"
          @click="toufangewizhi('wechaht')"
        >
          <svg
            viewBox="0 0 48 48"
            style="margin-right: 8px; width: 48px;"
          >
            <path
              data-role="tertiary"
              d="M15 24.5a.5.5 0 01.5-.5h9a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-1zM15 33.5a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-3zM15.5 28a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17z"
            />
            <path
              data-role="secondary"
              d="M15.5 20a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h9a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-9zM27.5 20a.5.5 0 00-.5.5v5a.5.5 0 00.5.5h5a.5.5 0 00.5-.5v-5a.5.5 0 00-.5-.5h-5z"
            />
            <path
              data-role="primary"
              d="M16 10c-.5523 0-1 .4477-1 1v5c0 .5523.4477 1 1 1h16c.5523 0 1-.4477 1-1v-5c0-.5523-.4477-1-1-1H16z"
            />
            <path
              data-role="primary"
              fill-rule="evenodd"
              d="M9 8c0-2.2091 1.7909-4 4-4h22c2.2091 0 4 1.7909 4 4v32c0 2.2091-1.7909 4-4 4H13c-2.2091 0-4-1.7909-4-4V8zm4-2h22c1.1046 0 2 .8954 2 2v32c0 1.1046-.8954 2-2 2H13c-1.1046 0-2-.8954-2-2V8c0-1.1046.8954-2 2-2z"
              clip-rule="evenodd"
            />
          </svg>
          <div class="item_xinxi">
            <span class="text">公众平台流量</span>
            <span class="text">向公众号、小程序、小游戏等微信公众平台流量场景下的用户展示广告</span>
          </div>
          <i class="item_icon">√</i>
        </li>
      </ul>
    </div>
    <div
      v-if="pos_type1 !== 999"
      class="deliveryPosition_platformDetails"
    >
      <div class="platformDetails_left">
        <div class="left_buttonArea">
          <div>
            <button
              class="button"
              :class="{active:pos_type1 === 101}"
              @click="postypeclick('xingtai')"
            >按形态投放</button>
            <button
              class="button"
              :class="{active:pos_type1 !== 101}"
              @click="postypeclick('gaunggaowei')"
            >按广告位投放</button>
          </div>
          <span>将广告投放到相同形态的多个广告位</span>
        </div>

        <!-- 按形态投放要显示的内容 -->
        <div
          v-if="pos_type1 === 101 && tuiguangtype!=='PRODUCTTYPE_WECHAT_ARTICLE'"
          class="left_tab"
        >
          <ul class="tab_box">
            <li
              v-for="item,index in rotation1"
              :key="index"
              :class="{
                'actives':index1 === index,
                'navlink':index === 0
              }"
              class="box_item"
              @click="xingtaiclick(index)"
            >
              <svg
                fill="none"
                viewBox="0 0 48 48"
              >
                <path
                  data-role="primary"
                  fill-rule="evenodd"
                  d="M15 21c-.5523 0-1 .4477-1 1v11c0 .5523.4477 1 1 1h18c.5523 0 1-.4477 1-1V22c0-.5523-.4477-1-1-1H15zm5.25 5.25c0 .9665-.7835 1.75-1.75 1.75s-1.75-.7835-1.75-1.75.7835-1.75 1.75-1.75 1.75.7835 1.75 1.75zM17.5 29.5a.5.5 0 00-.5.5v.5a.5.5 0 00.5.5h2a.5.5 0 00.5-.5V30a.5.5 0 00-.5-.5h-2z"
                  clip-rule="evenodd"
                />
                <path
                  data-role="primary"
                  fill-rule="evenodd"
                  d="M9 8c0-2.2091 1.7909-4 4-4h22c2.2091 0 4 1.7909 4 4v32c0 2.2091-1.7909 4-4 4H13c-2.2091 0-4-1.7909-4-4V8zm4-2h22c1.1046 0 2 .8954 2 2v32c0 1.1046-.8954 2-2 2H13c-1.1046 0-2-.8954-2-2V8c0-1.1046.8954-2 2-2z"
                  clip-rule="evenodd"
                />
                <path
                  data-role="secondary"
                  d="M15.5 12a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17zM15.5 16a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h12a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-12zM25.75 26.25c0 .9665-.7835 1.75-1.75 1.75s-1.75-.7835-1.75-1.75.7835-1.75 1.75-1.75 1.75.7835 1.75 1.75zM29.5 28c.9665 0 1.75-.7835 1.75-1.75s-.7835-1.75-1.75-1.75-1.75.7835-1.75 1.75S28.5335 28 29.5 28zM22.5 30a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v.5a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5V30zM28.5 29.5a.5.5 0 00-.5.5v.5a.5.5 0 00.5.5h2a.5.5 0 00.5-.5V30a.5.5 0 00-.5-.5h-2z"
                />
              </svg>
              <div class="item_xinxi">
                <span class="xinxi_text">{{ item.text }}</span>
                <span class="xinxi_text">{{ item.textr }}</span>
                <i v-if="index1 === index" class="item1_icon">√</i>
              </div>
            </li>

          </ul>
        </div>

        <!-- 按广告位投放 -->
        <div
          v-if="pos_type1 !== 101 && pos_type1 !== 999"
          class="left_tab"
        >
          <ul class="tab_box tab_box1">
            <li
              v-for="(item,index) in advertisingCard"
              :key="index"
              class="item1"
              :class="{
                active:activeAdvertisingCard === item.id
              }"
              @click="handid(item.id)"
            >
              <h3 class="item1_title">{{ item.title }}</h3>
              <p class="item1_tips">{{ item.tips }}</p>
              <i class="item1_icon">√</i>
            </li>
          </ul>
        </div>
      </div>
      <!-- 按形态投放要显示的轮播图 -->
      <div
        v-if="pos_type1 === 101 && tuiguangtype!=='PRODUCTTYPE_WECHAT_ARTICLE'"
        class="platformDetails_right"
      >
        <div class="right_rotation">
          <div class="rotationArea">
            <el-carousel
              trigger="click"
              height="100%"
              arrow="always"
            >
              <el-carousel-item
                v-for="item,index in rotation1[index1].rotationswiper"
                :key="index"
              >
                <div class="rotationArea_box">
                  <img
                    :src="item.img"
                    class="box_img"
                  >
                  <span class="box_text">{{ item.text }}</span>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>

      <div
        v-else
        class="platformDetails_right"
      >
        <div class="right_rotation1">
          <div class="rotationArea1">
            <div class="rotationArea1_box">
              <img
                :key="activeAdvertisingCard"
                :src="getAdvertisingCardImg"
                class="box_img"
                @load="hangeLoand"
              >
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    campaign_type: {
      default: 'CAMPAIGN_TYPE_WECHAT_MOMENTS'
    },
    product: {
      type: String
    },
    pos_type: {
      type: Number
    },
    multislottype: {
      type: Number
    }
  },
  data() {
    return {
      index1: 0, // 按形态展示id 三个选项
      option1: null,
      rotation1: [
        {
          img: 'http://wxa.wxs.qq.com/wxad-design/yijie/grid-preview_1.png',
          text: '展示Banner图片',
          textr: '广告位：公众号文章底部，小程序banner',
          rotationswiper: [
            {
              img: 'https://wxa.wxs.qq.com/images/create/pubBannerBottomBg.png',
              text: '公众号文章底部'
            },
            {
              img: 'http://wxa.wxs.qq.com/images/create/pubBannerProgramBg.png',
              text: '小程序banner'
            }
          ]
        },
        {
          img: 'https://wxa.wxs.qq.com/images/create/box_agency.png',
          text: '优雅横版大图',
          textr: '  广告位：公众号文章底部、中部，小程序插屏，小程序封面广告，支付订单详情页，订阅号消息列表广告',
          rotationswiper: [
            {
              img: 'http://wxa.wxs.qq.com/images/create/picPubBottom.png',
              text: '公众号文章底部'
            },
            {
              img: 'http://wxa.wxs.qq.com/images/create/picPubMiddle.png',
              text: '公众号文章中部'
            },
            {
              img: 'http://wxa.wxs.qq.com/images/create/picProgram.png',
              text: '小程序插屏广告'
            }
          ]
        },
        {
          img: 'http://wxa.wxs.qq.com/wxad-design/yijie/grid-preview_0.png',
          text: '沉浸式横版视频',
          textr: '广告位：公众号文章底部、公众号视频贴片、小程序激励视频、小程序视频广告、小程序视频前贴广告、插屏广告、支付订单详情页、订阅号消息列表广告',
          rotationswiper: [
            {
              img: 'http://wxa.wxs.qq.com/images/create/vedioPub.png',
              text: '公众号文章底部'
            },
            {
              img: 'http://wxa.wxs.qq.com/images/create/vedioPatch.png',
              text: '公众号文章视频贴片'
            },
            {
              img: 'http://wxa.wxs.qq.com/images/create/vedioDrive.png',
              text: '激励式广告'
            },
            {
              img: 'http://wxa.wxs.qq.com/images/paki/videoinsert.png',
              text: '小程序插屏广告'
            }
          ]
        }

      ],
      position: 'formDelivery',
      advertisingCard: [
        // {
        //   id: 0,
        //   title: '公众号文章底部',
        //   tips: '在文章底部展现广告，竞价广告可能被投放至小程序、支付后和公众号其它场景',
        //   img: '	https://wxa.wxs.qq.com/mpweb/delivery/legacy/assets/image/0.png'

        // },
        // {
        //   id: 5,
        //   title: '公众号文章中部',
        //   tips: '在文章中部展示你的广告，竞价广告可能被投放至小程序场景',
        //   img: 'https://wxa.wxs.qq.com/mpweb/delivery/legacy/assets/image/intext_without_avatar.png'

        // },
        // {
        //   id: 4,
        //   title: '公众号互选广告',
        //   tips: '选择优质流量主，达成合作后在流量主文章中展现你的广告',
        //   img: 'https://wxa.wxs.qq.com/mpweb/delivery/legacy/assets/image/4.png'

        // },
        // {
        //   id: 3,
        //   title: '公众号文章视频贴片',
        //   tips: '在文中视频播放时展示广告。为获取更多曝光，可能同时投放至小程序场景',
        //   img: 'https://wxa.wxs.qq.com/mpweb/delivery/legacy/assets/image/3.png'
        // },
        // {
        //   id: 7,
        //   title: '小程序banner广告',
        //   tips: '在小程序中向用户展现你的banner广告，小程序包含小游戏类目',
        //   img: 'https://wxa.wxs.qq.com/mpweb/delivery/legacy/assets/image/7.png'
        // },
        {
          id: 8,
          title: '激励式广告',
          tips: '在小程序流程中鼓励用户主动收看你的广告，小程序包含小游戏类目',
          img: 'https://wxa.wxs.qq.com/mpweb/delivery/legacy/assets/image/reward.png'
        }
        // {
        //   id: 10,
        //   title: '小程序插屏广告',
        //   tips: '在小程序中向用户展现你的插屏广告，小程序包含小游戏类目',
        //   img: '	https://wxa.wxs.qq.com/mpweb/delivery/legacy/assets/image/interstitial_ad.jpg'
        // },
        // {
        //   id: 14,
        //   title: '支付订单详情页',
        //   tips: '在微信扫码支付完成后的订单页面，展示你的广告。',
        //   img: 'http://wxa.wxs.qq.com/wxad-design/yijie/pay-before.png'
        // }
      ],
      activeAdvertisingCard: 8, // 回来改他 改成0
      tuiguangtype: '',
      pos_type1: null,
      multislottype1: null
    }
  },
  computed: {
    getAdvertisingCardImg() {
      return this.advertisingCard.filter(item => {
        return item.id === this.activeAdvertisingCard
      })[0].img
    }
  },
  watch: {
    option1(newValue) {
      this.option1 = newValue
    }
  },
  created() {
    console.log('multislottype', this.multislottype)
    this.tuiguangtype = this.product
    this.option1 = this.campaign_type
    this.setarr(this.pos_type)
    this.setarr2(this.multislottype)
  },
  methods: {
    setarr(pos_type) {
      if (pos_type === 101) {
        this.pos_type1 = pos_type
        return
      }
      if (pos_type === 999) {
        this.pos_type1 = pos_type
        return
      }
      if (pos_type !== 999 || pos_type !== 101) {
        this.activeAdvertisingCard = pos_type
        this.pos_type1 = pos_type
        return
      }
    },
    setarr2(multislottype) {
      this.multislottype1 = multislottype
      if (multislottype === 1) {
        console.log('1this.multislottype', multislottype)
        this.index1 = 0
        return
      }
      if (multislottype === 2) {
        console.log('1this.multislottype', multislottype)
        this.index1 = 1
        return
      }
      if (multislottype === 3) {
        console.log('1this.multislottype', multislottype)
        this.index1 = 2
        return
      }
      if (multislottype === 0) {
        console.log('1this.multislottype', multislottype)
        // 选择的是按广告位
        this.index1 = 1
        return
      }
    },
    hangeLoand(event) {
      const more = event.path[0].getBoundingClientRect().height - 380
      setTimeout(() => {
        event.path[0].style.top = -more + 'px'
      }, 1000)
    },
    toufangewizhi(type) {
      if (type === 'friend') {
        this.pos_type1 = 999
        this.$emit('setarr', {
          multi_slot_type: 0
        })
        this.$emit('setpostype', 999)
        return
      }
      if (type === 'wechaht') {
        if (this.multislottype !== 0) {
          console.log('按形态投放')
          this.pos_type1 = 101
          let idsw = this.index1
          const idr = idsw += 1
          this.$emit('setarr', {
            multi_slot_type: idr
          })
          this.$emit('setpostype', 101)
        }
        if (this.multislottype === 0) {
          console.log(this.activeAdvertisingCard)
          this.pos_type1 = this.activeAdvertisingCard
          this.$emit('setpostype', this.pos_type1)
          this.$emit('setarr', {
            multi_slot_type: 0
          })
          console.log('按广告位投放')
        }
      }
    },
    xingtaiclick(index) {
      if (index === 0) {
        return
      }
      this.index1 = index
      let idsw = this.index1
      const idr = idsw += 1
      this.$emit('setarr', {
        multi_slot_type: idr
      })
    },
    open(val) {
      this.tuiguangtype = val
      // this.$emit('setnameproducttype', this.tuiguangtype)
      console.log('val进来', val)
    },
    postypeclick(type) {
      if (type === 'xingtai') {
        console.log('按形态', this.index1)
        this.pos_type1 = 101
        let idsw = this.index1
        const idr = idsw += 1
        this.$emit('setarr', {
          multi_slot_type: idr
        })
        this.$emit('setpostype', this.pos_type1)
      }
      if (type === 'gaunggaowei') {
        console.log('按广告位投放')
        this.pos_type1 = this.activeAdvertisingCard
        this.$emit('setarr', {
          multi_slot_type: 0
        })
        this.$emit('setpostype', this.pos_type1)
      }
    },
    handid(id) {
      console.log('id', id)
      this.activeAdvertisingCard = id
      this.pos_type1 = id
      this.$emit('setarr', {
        multi_slot_type: 0
      })
      this.$emit('setpostype', this.pos_type1)
    }
  }
}
</script>

<style scoped lang="less">
.navlink{
  display: none !important;;
}
.actives{
  border: 1px solid #07c160;
    color: #07c160 !important;
    font-weight: 600;
}
.deliveryPosition {
  width: 100%;
  box-shadow: 0 0 0 1px hsla(0, 0%, 87%, 0.5), 0 3px 6px 0 rgba(0, 0, 0, 0.04);
  background-color: #fff;
  border-radius: 5px;
  padding-bottom: 25px;
  margin-top: 10px;
  .deliveryPosition_titleArea {
    padding: 16px 16px 20px 24px;
    margin-bottom: 8px;
    .title {
      font-size: 14px;
      font-weight: 600;
      color: #1f1f1f;
    }
    .tips {
      margin-top: 4px;
      font-size: 13px;
      color: #6b6b6b;
      display: inline-block;
    }
  }

  .deliveryPosition_option {
    width: 100%;
    .option_ul {
      width: 100%;
      display: flex;
      justify-content: space-around;
      .ul_item {
        width: 47%;
        display: flex;
        position: relative;
        border-radius: 4px;
        box-shadow: inset 0 0 0 1px #ebebeb;
        cursor: pointer;
        height: 84px;
        align-items: center;
        color: #ccc;
        &.active {
          color: #07c160;
          font-weight: 600;
          background-color: rgba(7, 193, 96, 0.02);
          box-shadow: inset 0 0 0 1px rgb(7 193 96 / 55%);
          svg {
            fill: #07c160;
          }
          .item_icon {
            background-color: #07c160;
          }
        }
        &:not(.active):hover {
          background-color: #fdfdfd;
          box-shadow: inset 0 0 0 1px #dfdfdf;
          color: #b9b9b9;
          svg {
            fill: #b9b9b9;
          }
        }
        svg {
          width: 48px;
          height: 48px;
          fill: #ccc;
        }
        .item_xinxi {
          display: flex;
          flex-direction: column;
          .text {
          }
        }

        .item_icon {
          font-style: normal;
          display: flex;
          color: #fff;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          justify-content: center;
          align-items: center;
          position: absolute;
          background-color: #ccc;
          top: 4px;
          right: 6px;
        }
      }
    }
  }

  .deliveryPosition_platformDetails {
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    .platformDetails_left {
      width: 50%;
      .left_buttonArea {
        span {
          margin-top: 10px;
          margin-bottom: 20px;
          font-size: 12px;
          line-height: 18px;
          color: rgb(163, 163, 163);
          display: inline-block;
        }
        .button {
          height: 30px;
          outline: none;
          cursor: pointer;
          color: #1f1f1f;
          background-color: #fff;
          box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.03), 0 0 0 1px #e0e0e0;
          padding: 0px 10px;
          border: none;
          &:first-child {
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
          }
          &:last-child {
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
          }
          &.active {
            background-color: #ebebeb;
            box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, 0.04), 0 0 0 1px #d6d6d6;
          }
          &:not(.active):hover {
            background-color: #f2f2f2;
            box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.03), 0 0 0 1px #d6d6d6;
          }
        }
      }

      .left_tab {
        .tab_box {
          .box_item {
            width: 100%;
            height: 84px;
            color: #a3a3a3;
            // background-color: #f5f5f8;
            box-shadow: inset 0 0 0 1px #e1e2e6;
            display: flex;
            align-items: center;
            cursor: pointer;
            border-radius: 6px;
            margin-bottom: 20px;
            svg {
              width: 48px;
              height: 48px;
              fill: #ccc;
            }
            .item_xinxi {
              display: flex;
              flex-direction: column;
              .xinxi_text {
              }
            }
          }
        }
      }

      .tab_box1 {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }

      .item1 {
        margin-bottom: 10px;
        width: 46%;
        height: 102px;
        padding: 12px 16px;
        position: relative;
        border-radius: 4px;
        box-shadow: inset 0 0 0 1px #ebebeb;
        cursor: pointer;
        .item1_title {
          margin-bottom: 4px;
          font-size: 13px;
          line-height: 20px;
          color: #1f1f1f;
        }
        .item1_tips {
          font-size: 12px;
          line-height: 18px;
          color: #6b6b6b;
        }
        .item1_icon {
          width: 14px;
          height: 14px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          color: #fff;
          background-color: #ccc;
          font-style: normal;
          position: absolute;
          top: 4px;
          right: 8px;
          display: none;
        }

        &.active {
          .item1_icon {
            display: flex;
            background-color: #07c160;
          }
          color: #07c160;
          font-weight: 600;
          background-color: rgba(7, 193, 96, 0.02);
          box-shadow: inset 0 0 0 1px rgb(7 193 96 / 55%);
        }
        &:not(.active):hover {
          .item1_icon {
            display: flex;
          }
          background-color: #fdfdfd;
          box-shadow: inset 0 0 0 1px #dfdfdf;
        }
      }
    }

    .platformDetails_right {
      width: 50%;
      display: flex;
      justify-content: center;
      .right_rotation {
        .rotationArea {
          width: 240px;
          height: 520px;
          background-image: url(https://wximg.qq.com/wxp/assets/image/paki/bg.png);
          background-size: 100%;
          background-repeat: no-repeat;
          padding: 37px 12px 0;
          position: relative;
          user-select: none;

          .el-carousel {
            height: 100%;
          }

          .rotationArea_box {
            position: relative;
            .box_img {
              width: 100%;
              height: 86%;
            }
            .box_text {
              position: absolute;
              bottom: -87px;
              left: 50%;
              transform: translateX(-50%);
              width: 141px;
              display: block;
              text-align: center;
            }
          }
        }
      }

      .right_rotation1 {
        .rotationArea1 {
          position: relative;
          margin: auto;
          padding: 37px 12px 63px;
          width: 240px;
          height: 476px;
          background: #fafbfc;
          background-image: linear-gradient(-180deg, #fff 1%, rgba(250, 251, 252, 0));
          border-radius: 20px;
          box-shadow: inset 0 0 0 2px #e3e4e6;
          &::before {
            content: '';
            position: absolute;
            top: 35px;
            left: 10px;
            width: 220px;
            height: 380px;
            box-shadow: inset 0 0 0 2px #bec0c2;
            border-radius: 2px;
          }
          &::after {
            content: '';
            position: absolute;
            left: 50%;
            bottom: 13px;
            margin-left: -18px;
            width: 36px;
            height: 36px;
            box-shadow: inset 0 0 0 2px #e3e4e6;
            border-radius: 100%;
          }

          .rotationArea1_box {
            width: 100%;
            height: 100%;
            overflow: hidden;
            .box_img {
              width: 100%;
              position: relative;
              transition: all 0.5s;
              top: 0px;
            }
          }
        }
      }
    }
  }
}
</style>
